export const SpamAnswerActors = {
    SPAM_ANSWER_LIST:'SPAM_ANSWER_LIST',
    SPAM_ANSWER_TOGGLE:'SPAM_ANSWER_TOGGLE'
}